import React, { useState } from "react";
import "./ProjectDoneSection.css";

const projects = [
  { title: "Dockyard Construction", company: "MNO Pvt Ltd", year: 2023, category: "Infrastructure" },
  { title: "Port Expansion", company: "ABC Ltd", year: 2023, category: "Infrastructure" },
  { title: "Fire Safety Compliance", company: "DEF Corp", year: 2022, category: "Compliance" },
  { title: "Environmental Compliance", company: "XYZ Ltd", year: 2022, category: "Compliance" },
  { title: "Statutory Audit", company: "LMN Industries", year: 2021, category: "Consulting" },
  { title: "Warehouse Optimization", company: "GHI Logistics", year: 2023, category: "Consulting" },
  { title: "Power Plant Safety Compliance", company: "EnergyPro Ltd", year: 2023, category: "Compliance" },
  { title: "Bridge Construction", company: "BridgeBuild Pvt Ltd", year: 2022, category: "Infrastructure" },
  { title: "Water Treatment Compliance", company: "PureWater Inc", year: 2021, category: "Compliance" },
  { title: "Factory Layout Design", company: "Industrial Works", year: 2023, category: "Consulting" },
  { title: "Port Logistics Management", company: "Harbor Solutions", year: 2022, category: "Consulting" },
  { title: "Road Construction Compliance", company: "Highway Builders", year: 2021, category: "Compliance" },
  { title: "Construction Site Audit", company: "BuildSafe Ltd", year: 2023, category: "Compliance" },
  { title: "Warehouse Expansion", company: "LogiPro Pvt Ltd", year: 2022, category: "Infrastructure" },
  { title: "Urban Planning Consultation", company: "CityPlan Inc", year: 2023, category: "Consulting" },
];

export default function ProjectDoneSection() {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = ["All", ...new Set(projects.map((project) => project.category))];

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  return (
    <section className="projects-done_pu8">
      <h2 className="section-title_pu8">Our Accomplished Projects</h2>

      <div className="category-filter_pu8">
        {categories.map((category) => (
          <button
            key={category}
            className={`filter-button_pu8 ${selectedCategory === category ? "active" : ""}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="projects-list_pu8">
        {filteredProjects.map((project, index) => (
          <div key={index} className="project-card_pu8">
            <div className="card-header_pu8">
              <h3 className="project-title_pu8">{project.title}</h3>
              <span className="project-year_pu8">{project.year}</span>
            </div>
            <p className="project-company_pu8">{project.company}</p>
            <p className="project-category_pu8">{project.category}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
